import type { OfferSiteBundle } from "./offerSite";

const stack = [
  "Kubernetes, Helm, Rancher, Docker",
  "AWS (EKS, RDS, S3, Shield), Hetzner bare-metal",
  "Terraform, Ansible, GitLab CI",
  "Prometheus, Grafana, Loki, ELK",
  "Cloudflare WAF/DDoS, Vault, PCI DSS",
  "PostgreSQL, MongoDB, Ceph, RabbitMQ",
  "Ollama / vLLM, RAG (ChromaDB) — сурам боюнча",
];

const proof = [
  { brand: "Raiffeisen Bank", note: "AWS, PCI, audit CI/CD" },
  { brand: "Crypto exchange", note: "EKS, WAF, нодалар, vaults" },
  { brand: "Epicenter / 27.ua", note: "Highload, Ceph, кластер" },
  { brand: "DDoS", note: "100 Gbps / кейс ~10M pps" },
];

/** Кыргызча: ишкер стиль, IT-терминдер эл аралык бойдон. */
export const ky: OfferSiteBundle = {
  seoHome: {
    title: "Алмашуу, төлөм жана highload инфраструктурасы | IT-24.pro",
    description:
      "Инфраструктура инженери: DDoS, PCI DSS, Kubernetes, нодалар, vaults. Банк жана биржа тажрыйбасы. Telegram, USDT/инвойс. Retainer $1 500/айдан.",
  },
  ui: { open: "Ачуу", forWhom: "Кимге", includes: "Эмне кирет" },
  nav: {
    services: "Кызматтар",
    cases: "Кейстер",
    about: "Мен жөнүндө",
    contacts: "Байланыш",
    telegramCta: "Telegramга жазуу",
  },
  hero: {
    eyebrow: "IT-24.pro · алмашуу · төлөм · highload",
    h1: "Токтоп калса — акча кеткен инфраструктура",
    lead:
      "Биржа, төлөм жана жүктөмү жогору сервистердин production'ун курам жана кармап турам: DDoS, PCI DSS, Kubernetes, сырлар жана нодалар. Өзүм иштейм — Telegram аркылуу жооп берем.",
    ctaTg: "Telegramга жазуу",
    ctaOffers: "Кызматтар жана баа",
    chips: ["PCI DSS L1/L2", "DDoS 100+ Gbps", "USDT / PL инвойс", "2010-жылдан инфраструктурада"],
  },
  proofTitle: "Аты бар тажрыйба",
  proofLead: "Резюме жана кейстерден текшерсе болот — «500+ долбоор» жок.",
  proof,
  offersTitle: "Кызматтар",
  offersLead: "Төрт формат. VPS жана «$80га админ» тарифтери жок.",
  offers: [
    {
      id: "incident",
      href: "/services/incident",
      title: "Шашылыш жардам",
      price: "$100–150/саат · пакет $600дан",
      blurb: "Бузулуу, DDoS же кирүү жоголгондо production'ду көтөрөм.",
      bullets: ["Telegramда реакция", "Инциденттен кийин талдоо", "Абоненттик келишимсиз"],
    },
    {
      id: "audit",
      href: "/services/audit",
      title: "Аудит 1–2 күн",
      price: "$300–600",
      blurb: "Инфраструктура тобокели, PCI DSSке даярдык жана чабуулга туруктуулук.",
      bullets: ["Жазуу отчёт", "Эмнеден баштоо", "30–60 мүнөт чалуу"],
    },
    {
      id: "retainer",
      href: "/services/retainer",
      title: "Retainer — инфраструктураны коштоо",
      price: "$1 500–2 500/ай",
      blurb: "Алмашуу жана финтех үчүн сырткы DevOps: релиз, мониторинг, инцидент.",
      bullets: ["40–80 саат эквиваленти", "Telegram-канал", "Калыбына келтирүүсү текшерилген бэкап"],
    },
    {
      id: "projects",
      href: "/services/projects",
      title: "Ачкычка долбоор",
      price: "$3 000–8 000 fixed",
      blurb: "PCI DSS контуру, DDoS коргоо, миграция, Kubernetes жана CI/CD, нодалар жана сыр сактагыч.",
      bullets: ["2–4 жума", "Бекитилген баа", "Өткөрүп берүү документтери"],
    },
  ],
  payTitle: "Кантип төлөшөт",
  payItems: ["USDT (TRC-20)", "KGS", "Wise / Payoneer", "Польша инвойсу (VAT)"],
  payNote: "Польшадагы юридикалык жак — ЕБ кардарлары жана USDT эсептешүүгө ыңгайлуу.",
  howTitle: "Кантип баштайбыз",
  howSteps: [
    { t: "Telegramга кабар", p: "Кыскача: эмне күйүп жатат, стек, бюджет." },
    { t: "30 мүнөттүк чалуу", p: "Инцидент, аудит, retainer же бир жолку долбоор." },
    { t: "Аудит же пилот", p: "Кичине кириш — жылдык келишимсиз." },
    { t: "Retainer же fixed", p: "Андан ары — коштоо же жыйынтыгы түшүнүктүү долбоор." },
  ],
  aboutTeaser: {
    title: "Игорь Косицын",
    text: "DevOps / MLOps, Konin (PL). Linux highload 2010-жылдардан, cloud-native акыркы жылдары. Юридикалык жак Польшада.",
    link: "Кеңири",
  },
  footerTagline:
    "Алмашуу, финтех жана жүктөмү жогору системалардын инфраструктурасы. КМШ рыногу · PL юридикалык жак · Telegram.",
  footerEuNote: "EU рыногу үчүн — өзүнчө сайт",
  footerEuLink: "nexops.eu",
  casesPage: {
    seo: {
      title: "Кейстер: банк, биржа, DDoS, highload | IT-24.pro",
      description: "Мисалдар: PCI DSS, биржа инфраструктурасы, чабуулдан коргоо, e-commerce highload.",
    },
    h1: "Кейстер",
    lead: "Милдет, эмне кылдым, эмне менен бүттү.",
    labels: { problem: "Милдет", did: "Чечим", result: "Жыйынтык" },
    items: [
      {
        title: "Криптобиржа: production жана комплаенс",
        problem: "Кол менен релизсиз алмашуу жана нода инфраструктурасы, сырларды көзөмөлдөө керек болчу.",
        did: "AWS EKS жана bare-metal Kubernetes, Helm, GitLab CI, WAF, Ceph, нодалар, vaults, Ansible жана Terraform.",
        result: "Кол менен түйшүксүз релиз, аудитке даяр контур, production'до коштоо.",
      },
      {
        title: "Raiffeisen: миграция жана PCI DSS",
        problem: "Инфраструктураны көчүрүү жана финансы секторунун аудит менен кирүү талаптары.",
        did: "AWS'ка миграция, Kubernetes, CI/CD hardening, PCI DSS Level 1/2 даярдыгына инфраструктура тараптан катышуу.",
        result: "Текшерүүгө даярдык жана кайталануучу деплойлор.",
      },
      {
        title: "Жарнамалык ишке киргизүүдөгү DDoS",
        problem: "Секундасына ~10 млн пакетке чейин чоку; дата-борборлор чабуулду чыпкалаган эмес.",
        did: "L3–L7 чыпка, маанилүү сервистерди корголгон контурга көчүрүү, мониторинг, резерв маршруттар.",
        result: "Чабуулдун бир айында аудиториянын болжол менен 80% кире алган.",
      },
      {
        title: "E-commerce / ритейл, highload",
        problem: "Жүктөм чокулары, жүздөгөн терабайт кампа, ар кайсы аймактан кирүү.",
        did: "Nginx, MySQL, Ceph, кластерлер, кэш, Украина — Франция схемасы.",
        result: "Жүктөмдө туруктуу иш жана маалыматтарды корголгон сактоо.",
      },
    ],
  },
  aboutPage: {
    seo: {
      title: "Мен жөнүндө — Игорь Косицын, DevOps/MLOps | IT-24.pro",
      description: "Алмашуу жана финтех инфраструктурасынын инженери. Польша, банк жана биржа, PCI DSS, DDoS, Kubernetes.",
    },
    h1: "Мен жөнүндө",
    lead: "Игорь Косицын. DevOps / MLOps: инфраструктураны өзүм долбоорлойм жана кармап турам, сайтта «жыйырма кишилик команда» жок.",
    body: [
      "Юридикалык жак Польшада (Konin). Мурун Украинада инфраструктура курдум: банк, ритейл, биржалар.",
      "Токтоп калуу же бузуу акча менен текшерүүгө тийген милдеттерди алам: төлөм, алмашуу, чоку жүктөм, PCI DSSке даярдык.",
      "ЕБ кардарларын nexops.eu'да алып барам. IT-24.pro — КМШ буйрутмачылары үчүн.",
    ],
    stackTitle: "Стек",
    stack,
  },
  contactsPage: {
    seo: {
      title: "Байланыш — Telegram, USDT төлөм | IT-24.pro",
      description: "Telegram @devops_it24. USDT, KGS, Польша инвойсу.",
    },
    h1: "Байланыш",
    lead: "Негизги канал — Telegram. Өзүм жооп берем, тикет кезеги жок.",
    tgHint: "Кыскача: стек жана азыр эмне оорутат.",
    payTitle: "Төлөм",
    payItems: ["USDT TRC-20", "KGS", "Wise / Payoneer", "PL инвойс (VAT)"],
    payNote: "Польшадагы юридикалык жак — ЕБ кардарлары жана USDT үчүн ыңгайлуу.",
  },
  services: {
    incident: {
      id: "incident",
      path: "/services/incident",
      seo: {
        title: "Инфраструктура боюнча шашылыш жардам — инцидент жана DDoS | IT-24.pro",
        description:
          "Чабуул, компрометация же сервис кулагандан кийин production'ду калыбына келтирүү. $100–150/саат же $600дан пакет. Telegram.",
      },
      breadcrumb: "Шашылыш жардам",
      h1: "Шашылыш жардам",
      lead: "Production жатса — адегенде жеткиликтүүлүктү көтөрөм, анан себебин карайм. Инцидент ортосунда «Growth пакетин» тандатпайм.",
      price: "$100–150/саат · инцидент пакети $600дан",
      forWhom: [
        "Алмашуу, төлөм жана жарнама бюджети бар сервистер",
        "Өз DevOps on-call жок",
        "Чабуул, компрометация, кирүүнү жоготуу, дайынга коркунуч",
      ],
      includes: [
        "Диагностика жана жеткиликтүүлүктү калыбына келтирүү",
        "Баштапкы hardening (кирүү, firewall, ачык тешиктер)",
        "Кыска post-mortem: эмне болду жана кийин эмне оңдоо",
        "Макулдашуу боюнча — аудитке же retainerге өтүү",
      ],
      cta: "Инцидент тууралуу Telegramга жазуу",
    },
    audit: {
      id: "audit",
      path: "/services/audit",
      seo: {
        title: "Инфраструктура аудити жана PCI DSS даярдыгы | IT-24.pro",
        description: "1–2 күндүк аудит: коопсуздук, DDoS контуру, булут эсеби, PCI DSS. $300–600.",
      },
      breadcrumb: "Аудит",
      h1: "Аудит 1–2 күн",
      lead: "Тобокел аныктыгы үчүн төлөйсүз — жылдык келишимсиз.",
      price: "$300–600 fixed",
      forWhom: [
        "PCI DSS же тышкы аудитке даярдык",
        "Булут провайдериндеги эсеп өсүп жатат",
        "Контурдун чабуулга же чокуга туруштук берүүсү түшүнүксүз",
      ],
      includes: [
        "Архитектура, кирүү, бэкап, мониторинг кароосу",
        "Артыкчылык боюнча тобокел тизмеси",
        "Жоюу бюджетинин баасы (retainer же долбоор)",
        "Отчёт боюнча чалуу",
      ],
      cta: "Telegramда аудитке буйрутма",
    },
    retainer: {
      id: "retainer",
      path: "/services/retainer",
      seo: {
        title: "Алмашуу жана финтех үчүн DevOps retainer | IT-24.pro",
        description: "Айлык коштоо $1 500–2 500: релиз, мониторинг, инцидент, бэкап.",
      },
      breadcrumb: "Retainer",
      h1: "Retainer — инфраструктураны коштоо",
      lead: "$100 хостинг менен эмес, өргүүсү жана bus factor'у бар Middle/Senior DevOps $2.7–5k/ай менен салыштырыңыз.",
      price: "$1 500–2 500 / ай",
      forWhom: [
        "Алмашуу, төлөм, финтех же highload-продукт",
        "Кардар долбоорлорунда өз DevOps'у жок студия",
        "Тикет кызматы эмес, Telegramдагы жооптуу адам керек",
      ],
      includes: [
        "Макулдашылган терезеде мониторинг жана инцидент реакциясы",
        "Саат чегинде релиз, CI/CD жана инфраструктура оңдоолору",
        "Жаңыртуу, бэкап, калыбына келтирүүнү мезгил-мезгили менен текшерүү",
        "Айына кыска отчёт: жасалганы жана тобокел зоналары",
      ],
      cta: "Telegramда retainer талкуулоо",
    },
    projects: {
      id: "projects",
      path: "/services/projects",
      seo: {
        title: "PCI DSS, DDoS, Kubernetes — ачкычка долбоорлор | IT-24.pro",
        description:
          "Бекитилген баа $3–8k: PCI DSS контуру, DDoS коргоо, миграция, Kubernetes жана CI/CD, нодалар жана vaults.",
      },
      breadcrumb: "Долбоорлор",
      h1: "Ачкычка долбоор",
      lead: "Айлык «саат» эмес, 2–4 жумада түшүнүктүү жыйынтык керек болгондо.",
      price: "$3 000–8 000 fixed · 2–4 жума",
      forWhom: [
        "Инфраструктураны PCI DSSке даярдоо",
        "Инциденттен кийин же ишке киргизүү алдында DDoS / WAF контуру",
        "Миграция (булут ↔ bare-metal), нөлдөн Kubernetes, нодалар жана vaults",
      ],
      includes: [
        "Баштоодон мурун скоп жана бекитилген баа",
        "IaC, документтер, кирүүнү өткөрүп берүү",
        "Кабыл алуу критерийлери (жеткиликтүүлүк, пайплайн, бэкаптан калыбына келтирүү)",
        "Опция: ишке киргизгенден кийин коштоо (retainer)",
      ],
      cta: "Долбоорду Telegramда сүрөттөө",
    },
  },
};
